<template>
  <div :style="marketDetails">
    <table
      v-if="market"
      class="market"
    >
      <tr class="market-row">
        <td
          v-if="silkImageUrl"
          class="silk"
        >
          <img
            :src="silkImageUrl"
            alt=""
          >
        </td>
        <td class="number">
          {{ market.num }}
        </td>
        <td class="runner">
          <div
            class="name"
            :class="{scratched: market.scratched}"
          >
            {{ market.name }}
          </div>
          <div class="data">
            <span class="market-data-jockey">{{ market.jockey }}</span> <span v-if="!market.scratched && market.jockey && market.trainer">|</span>
            <span class="market-data-trainer">{{ market.trainer }}</span>
          </div>
        </td>
        <td class="name-spacer" />
        <td
          class="price"
          :style="currentPrice"
        >
          <span
            v-if="market.price"
          >{{ displayPrice }}</span>
          <span v-if="!market.price && !market.scratched">SP</span>
        </td>
        <td
          class="prev"
          :style="previousPrice"
        >
          <span v-if="market.previousPrice">{{ previousDisplayPrice }}</span>
          <span v-if="!market.previousPrice && !market.scratched">SP</span>
          <span>&nbsp;</span>
        </td>
        <td
          class="place"
          :style="placePrice"
        >
          {{ placeDisplayPrice }} &nbsp;
        </td>
      </tr>
    </table>
    <div class="clearfix" />
  </div>
</template>

<script>
export default {
  name: 'MarketSmall',
  props: ['scrollMarkets', 'placesPaid', 'placePercentage', 'venueId', 'raceId', 'marketId', 'venueIndex', 'isMulti', 'quadrant'],
  data() {
    return {
      indexedMarketId: '',
      mCount: 0,
      scrollMarketIndex: 0
    };
  },
  computed: {
    marketStyle() {
      return this.$store.getters.marketStyle;
    },
    silkImageUrl() {
      if(this.market.silks){
        return unescape(this.market.silks);
      }
      return null;
    },
    placePricePercentage() {
      if(this.market.price) {
        return +(this.market.price * (this.placePercentage / 100)).toFixed(2);
      }

      return '';
    },
    marketDetails() {
      return this.$store.getters.marketDetails;
    },
    currentPrice() {
      return this.$store.getters.currentPrice;
    },
    previousPrice() {
      return this.$store.getters.previousPrice;
    },
    placePrice() {
      return this.$store.getters.placePrice;
    },
    market() {
      let venue = null;

      if (this.isMulti) {
        const quadvenues = this.$store.state.screenData.filter(item => item.quadrant === this.quadrant);

        venue = quadvenues[this.venueIndex];
      } else {
        venue = this.$store.state.screenData[this.venueIndex - 1];
      }

      if (venue) {
        const race = venue.races.find(item => item.raceId === this.raceId);

        if(race) {
          let market = race.markets.find(item => item.marketId === this.indexedMarketId);

          if (market) {
            return market;
          }
        }
      }

      return {};
    },
    displayPrice() {
      const fraction =this.$store.state.fractionTable.find(fraction => {
        return this.market.price >= fraction.priceFrom && this.market.price <= fraction.priceTo;
      });

      return fraction && this.$store.state.screenConfig.priceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : this.market.price;
    },
    previousDisplayPrice() {
      const fraction =this.$store.state.fractionTable.find(fraction =>
        this.market.previousPrice >= fraction.priceFrom && this.market.previousPrice <= fraction.priceTo
      );

      return fraction && this.$store.state.screenConfig.previousPriceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : this.market.previousPrice;
    },
    placeDisplayPrice() {
      const fraction =this.$store.state.fractionTable.find(fraction =>
        this.market.previousPrice >= fraction.priceFrom && this.market.previousPrice <= fraction.priceTo
      );

      return fraction && this.$store.state.screenConfig.placePriceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : this.placePricePercentage;
    }
  },
  watch: {
    marketId: function(newMarketId) {
      this.indexedMarketId = newMarketId;
    },
    raceId: function() {
      this.scrollMarketIndex = 0;

      if (this.scrollMarkets){
        this.indexedMarketId = this.scrollMarkets[this.scrollMarketIndex].marketId;
      }
    }
  },
  created: function() {
    this.indexedMarketId = this.marketId;

    if (this.scrollMarkets && this.scrollMarkets.length) {
      this.indexedMarketId = this.scrollMarkets[0].marketId;

      this.startScrollingMarkets(0);
    }
  },
  methods: {
    startScrollingMarkets() {
      setTimeout(() => {
        this.indexedMarketId = this.scrollMarkets[this.scrollMarketIndex].marketId;
        this.scrollMarketIndex++;

        if (this.scrollMarketIndex >= this.scrollMarkets.length) {
          this.scrollMarketIndex = 0;
        }

        this.startScrollingMarkets();
      }, this.$store.state.screenConfig.marketScrollInterval * 1000);
    }
  }
};
</script>

<style scoped>
.market {
    table-layout:fixed;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}
.market-row {
    border-bottom: 1px solid #000;
    height: 30px;
}
.silk {
    width: 30px;
    padding-left: 10px;
}
.silk img {
    width: 20px;
}
.number {
    font-size: 20px;
    width: 60px;
    padding-left: 10px;
    text-align: center;
}

.runner {
    overflow:hidden;
    white-space:nowrap;
    padding-left:10px;
}

.name {
    font-size: 15px;
    font-weight: bold;
    padding-top: 2px;
    height: 20px;
    line-height: 20px;
}

.data {
    font-size: 10px;
    line-height: 10px;
    font-style: italic;
}

.market-data-jockey {
    margin-right: 10px;
}

.market-data-trainer {
    margin-left: 10px;
}
.name-spacer{
    width: 10px;
}
.price {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    width: 105px;
}
.odds-on-price {
    color: red;
}

.prev {
    font-size: 20px;
    padding-top: 4px;
    text-align: center;
    width: 70px;
}

.place {
    font-size: 10px;
    padding-top: 7px;
    text-align: center;
    width: 70px;
}

.scratched {
    text-decoration: line-through;
}
</style>


// WEBPACK FOOTER //
// MarketSmall.vue?7761bcc4